module.exports = __webpack_public_path__ + "img/DE04072.7f8acfa6.png";